module.exports = __webpack_public_path__ + "static/media/saft.8d447173.png";